import { connect } from 'react-redux';
import ProfileView from './ProfileView';
import * as Actions from './ProfileActions';
import { selectIsHiddenLeversRTQ, selectPortalName } from '../CommonSelectors/CommonAreaSelector';

const ProfileContainer = connect(
  (state, ownProps) => {
    const { clientId } = ownProps;
    const subdivision = state.Profile.Main[clientId];
    return {
      ...subdivision,
      ...ownProps,
      clientId,
      isAdviserArea: state.Profile.Main.isAdviserArea,
      page: ownProps.page || ownProps.pageId,
      portalName: selectPortalName(state),
      isHiddenLeversRTQ: selectIsHiddenLeversRTQ(state),
    };
  },

  dispatch => ({
    initializeSection(clientId, isAdviserArea, page, pivotId, stepId) {
      dispatch(Actions.initializeSection(clientId, isAdviserArea, page, pivotId, stepId));
    },
  }),
)(ProfileView);

export default ProfileContainer;
